import {Variables} from './variables';

export class FeatureTypes {
  public Name: string;
  public Context: string;
  public Variable: Variables[];

  constructor(name: string) {
    this.Name = name;
    this.Variable = [];
  }

  public AddNewVariable(variable: Variables) {
    this.Variable.push(variable);
  }

}
